import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d67fbe7mvg9ih2c794u0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="relative py-32 px-6 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20developer%20workspace%20panoramic%20view%20wide%20angle%20clean%20minimalist%20desk%20setup%20multiple%20monitors%20keyboard%20coffee%20natural%20lighting%20professional%20coding%20environment%20warm%20ambient%20light%20soft%20shadows&width=1920&height=800&seq=contact001&orientation=landscape"
          alt="Contact Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col justify-between min-h-[600px]">
          <div>
            <h2 className="text-7xl font-bold text-white lowercase leading-tight">
              {t('contact.title')}<br />{t('contact.subtitle')}
            </h2>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-end gap-12 mt-20">
            <div className="w-full md:w-auto">
              <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="bg-white/10 backdrop-blur-md rounded-3xl p-8 max-w-md">
                <h3 className="text-2xl font-bold text-white mb-6">{t('contact.description')}</h3>
                
                <div className="space-y-4">
                  <input
                    type="text"
                    name="name"
                    placeholder={t('contact.form.name')}
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full bg-white/20 border border-white/30 text-white placeholder-white/60 px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-white/50"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder={t('contact.form.email')}
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full bg-white/20 border border-white/30 text-white placeholder-white/60 px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-white/50"
                  />
                  <input
                    type="text"
                    name="subject"
                    placeholder={t('contact.form.subject')}
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full bg-white/20 border border-white/30 text-white placeholder-white/60 px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-white/50"
                  />
                  <textarea
                    name="message"
                    placeholder={t('contact.form.message')}
                    value={formData.message}
                    onChange={handleChange}
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full bg-white/20 border border-white/30 text-white placeholder-white/60 px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-white/50 resize-none"
                  ></textarea>
                  <div className="text-xs text-white/60 text-right">
                    {formData.message.length}/500 caractères
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full mt-6 bg-white text-[#0A0A0A] px-8 py-4 rounded-full font-bold flex items-center justify-center gap-3 hover:bg-[#0066FF] hover:text-white transition-all duration-300 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? t('contact.form.sending') : t('contact.form.send')}
                  <div className="w-8 h-8 bg-[#0A0A0A] rounded-full flex items-center justify-center">
                    <i className="ri-arrow-right-line text-white"></i>
                  </div>
                </button>

                {submitStatus === 'success' && (
                  <div className="mt-4 p-4 bg-green-500/20 border border-green-500/50 rounded-xl text-white text-sm">
                    {t('contact.form.success')}
                  </div>
                )}
                {submitStatus === 'error' && (
                  <div className="mt-4 p-4 bg-red-500/20 border border-red-500/50 rounded-xl text-white text-sm">
                    {t('contact.form.error')}
                  </div>
                )}
              </form>
            </div>

            <div className="text-right space-y-4">
              <div>
                <div className="text-xl text-white font-light">+221 76 617 82 84</div>
              </div>
              <div>
                <div className="text-xl text-white font-light">sadiocherif11@gmail.com</div>
              </div>
              <div className="mt-8">
                <div className="text-sm text-white/60 mb-2">Localisation</div>
                <div className="text-xl text-white font-light">Dakar, Sénégal</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
